import { Header, Support } from '@/components';

import { MainWrapper } from '@/styles/global.elements';

const TermsOfUse = () => (
  <MainWrapper light>
    <Header light />
    <Support type={'termsOfUse'} />
  </MainWrapper>
);

export default TermsOfUse;
